import { Button, DatePicker, Modal } from 'antd';
import locale from 'antd/es/date-picker/locale/ko_KR';
import moment from 'moment';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { httpPost, httpUrl } from '../../api/httpClient';
import {
  allCategoryCode,
  categoryCode,
  pointType,
  modalErrorStyle,
} from '../../lib/util/codeUtil';
import { comma } from '../../lib/util/numberUtil';
import Pagination from '../input/Pagination';
import NcashMempDetailModal from '../modal/NcashMempDetailModal';
import Const from "../../const";
import image from '../../res/image';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const dateTimeFormat = 'YYYY-MM-DD HH:00:00';
const now = new Date();
const now2 = new Date();
const PagedListSize = 5;

const header = [
  {
    orderIdx: '주문번호',
    createDate: '일시',
    category: '분류',
    pointType: '적립/차감',
    ncashDelta: '금액',
    afterNcash: '거래 후 잔액',
    misu: '미수금',
    ncashDeltaMisu: '미수금증감분',
  },
];
const defDateType = {
  daily: 0,
  weekly: 1,
  monthly: 2,
  range: 3,
};

const AllList = () => {
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 9,
    startDate: now,
    endDate: now,
  });

  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectCategory, setSelectCategory] = useState(
    Object.keys(allCategoryCode)
  );
  const [selectedRow, setSelectedRow] = useState(null);
  const [isOpenRangePicker, setIsOpenRangePicker] = useState(false);
  const [dateType, setDateType] = useState(defDateType.daily);

  useEffect(() => {
    getListAsync();
  }, [pagination, selectCategory]);

  const getListAsync = async () => {
    const pageNum = pagination.current;
    const pageSize = pagination.pageSize;
    const startDate = moment(pagination.startDate)
      .hour(0)
      .format(dateTimeFormat);
    const endDate = moment(pagination.endDate)
      .add(1, 'day')
      .format(dateTimeFormat);

    try {
      const res = await httpPost(httpUrl.allList, [], {
        pageNum,
        pageSize,
        startDate,
        endDate,
        categories: selectCategory,
      });
      if (res.result !== 'SUCCESS') {
        setList([]);
        setTotal(0);
        return;
      }

      if (res.data !== null) {
        setList(res.data.ncashList1);
        setTotal(res.data.totalCount);
      }
    } catch (e) {
      setList([]);
      setTotal(0);
      console.warn('getListAsync failed. ' + e);
    }
  };
  const onCheckList = (id) => {
    var selectedList = selectCategory;

    if (selectCategory.includes(id)) {
      // 클릭한 ID가 활성화일 때

      if (id == 'ALL') {
        // 카테고리 '전체'를 선택한 경우
        setSelectCategory([]);
        // 카테고리 모두 해제
      } else {
        setSelectCategory(
          selectedList.filter(
            (x) =>
              x !== id && !categoryCode[id].children.includes(x) && x !== 'ALL'
          )
        );
        // 클릭한 ID만 해제
      }
    } else {
      // 클릭한 ID가 비활성화일 때

      if (id == 'ALL') {
        // 카테고리 '전체' 를 선택한 경우

        let idArray = [];
        Object.keys(categoryCode).forEach(function (key, value) {
          // idArray.push(key);
          idArray = [...idArray, key, ...categoryCode[key].children];
        });
        setSelectCategory(idArray);
        // 카테고리 모두 선택
      } else {
        setSelectCategory([...selectedList, id, ...categoryCode[id].children]);
        // 클릭한 ID만 추가
      }
      if (Object.keys(categoryCode).length - 2 === selectedList.length) {
        // 카테고리 '전체'를 제외한 하위 카테고리가 모두 선택된 경우

        let idArray = [];
        Object.keys(categoryCode).forEach(function (key, value) {
          idArray = [...idArray, key, ...categoryCode[key].children];
        });
        setSelectCategory(idArray);
        // 카테고리 '전체'도 선택
      }
    }
  };

  const onChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  const onChangeDatePickerStart = (_, dateString) => {
    var afterMonth = moment(dateString).add(+3, 'M').format(dateFormat);
    var beforeMonth = moment(dateString).add(-3, 'M').format(dateFormat);
    if (dateString) {
      if (new Date(pagination.endDate) - new Date(dateString) > 0) {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
        });
        if (new Date(pagination.endDate) - new Date(afterMonth) > 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: dateString,
            endDate: afterMonth,
          });
        }
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: pagination.endDate,
          endDate: dateString,
        });
        if (new Date(pagination.endDate) - new Date(beforeMonth) < 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: beforeMonth,
            endDate: dateString,
          });
        }
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: moment(now).format(dateFormat),
      });
    }
  };

  const onChangeDatePickerEnd = (_, dateString) => {
    var beforeMonth = moment(dateString).add(-3, 'M').format(dateFormat);
    var afterMonth = moment(dateString).add(+3, 'M').format(dateFormat);
    if (dateString) {
      if (new Date(pagination.startDate) - new Date(dateString) < 0) {
        setPagination({
          ...pagination,
          current: 1,
          endDate: dateString,
        });
        if (new Date(pagination.startDate) - new Date(beforeMonth) < 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: beforeMonth,
            endDate: dateString,
          });
        }
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
          endDate: pagination.startDate,
        });
        if (new Date(pagination.startDate) - new Date(afterMonth) > 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: dateString,
            endDate: afterMonth,
          });
        }
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: moment(now).format(dateFormat),
      });
    }
  };

  const onChangeRangePicker = (_, dateString) => {
    // const startDate = dateString[0];
    // const endDate = dateString[1];
    var afterDateStringStart = dateString[0].split('-');
    var afterDateStringEnd = dateString[1].split('-');
    if (dateString[0]) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: dateString[0],
        endDate: dateString[1],
      });
      if (
        parseInt(afterDateStringEnd[1]) - parseInt(afterDateStringStart[1]) >
        3
      ) {
        alert('3달이내로 설정해주세요.');
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString[0],
          endDate: moment(dateString[0]).add(+3, 'M'),
        });
      } else {
        return;
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M'),
        endDate: now,
      });
    }
  };

  const onChangeDateType = (dateType) => {
    let startDate, endDate;
    let isOpenRangePicker = false;

    switch (dateType) {
      case defDateType.daily:
        startDate = now;
        endDate = now;
        break;

      case defDateType.weekly:
        startDate = moment(now).add(-7, 'days');
        endDate = now;
        break;

      case defDateType.monthly:
        startDate = moment(now).add(-30, 'days');
        endDate = now;
        break;

      case defDateType.range:
        isOpenRangePicker = true;
        break;

      default:
        return;
    }

    setDateType(dateType);
    setIsOpenRangePicker(isOpenRangePicker);

    if (dateType !== defDateType.range) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: startDate,
        endDate: endDate,
      });
    }
  };

  const onDownload = async () => {
    const startDate = moment(pagination.startDate)
      .hour(0)
      .format(dateTimeFormat);
    const endDate = moment(pagination.endDate)
      .add(1, 'day')
      .format(dateTimeFormat);
    const pageNum = 1;
    const pageSize = total;

    const res = await httpPost(httpUrl.allList, [], {
      endDate,
      pageNum,
      pageSize,
      startDate,
      categories: selectCategory,
    });

    if (res.result !== 'SUCCESS') {
      Modal.error({
        title: '엑셀 다운로드 오류',
        content: (
          <div>
            엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    const title = '통계';
    const filename = moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';

    const jsonData = res.data.ncashList1.map((row) => ({
      orderIdx: row.orderIdx,
      createDate: moment(row.createDate).format('YYYY-MM-DD HH:mm'),
      category: allCategoryCode[row.category],
      pointType:
        row.ncashDelta == null
          ? pointType[0]
          : row.ncashDelta > 0
          ? pointType[1]
          : row.ncashDelta < 0
          ? pointType[2]
          : '',
      ncashDelta: row.ncashDelta,
      afterNcash: row.afterNcash,
      misu: ((row.misu1 ?? 0) + (row.misu2 ?? 0) + (row.misu3 ?? 0)),
      ncashDeltaMisu: row.ncashDeltaMisu ?? 0,
    }));

    const array = header.concat(jsonData);

    var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
    var wb = XLSX.utils.book_new();

    ws['!cols'] = [];
    ws['!cols'][1] = { width: 20 };
    ws['!cols'][2] = { width: 15 };

    XLSX.utils.book_append_sheet(wb, ws, '전체내역');
    XLSX.writeFile(wb, filename);
  };

  const openDetailModal = (memo) => {
    setSelectedRow(memo);
    setDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setSelectedRow(null);
    setDetailModalOpen(false);
  };

  const skinType = Const.skinType.toUpperCase();
  return (
    <div className="calculate-element-sub">
      <NcashMempDetailModal
        data={selectedRow}
        isOpen={detailModalOpen}
        close={closeDetailModal}
      />
      <div className="calculate-element-sub-content">
        <div className="calculate-element-menu-check">
          <div
            className="calculate-element-menu-check-sub"
            onClick={() => {
              setSelectOpen(!selectOpen);
            }}>
            <div
              className={selectOpen && skinType === "GOGOIT" ?
                  'gogoit-calculate-element-menu-check-all-color'
                  :
                selectOpen
                  ? 'calculate-element-menu-check-all-color'
                  : 'calculate-element-menu-check-all'
              }>
              분류선택
              <img
                style={{ display: 'inline' }}
                src={selectOpen ? image.SelectIcon : image.UnselectIcon}
                alt=""
                className="select-img2"
              />
            </div>
          </div>
          {selectOpen && (
            <div className="calculate-element-menu-check-menu">
              {Object.keys(categoryCode).map((key) => (
                <div key={key}>
                  <div className="all-category-box">
                    <div
                      className={selectCategory.includes(key) && skinType === "GOGOIT" ?
                          'gogoit-calculate-element-menu-check-element'
                          :
                        selectCategory.includes(key)
                          ? 'calculate-element-menu-check-element'
                          : 'calculate-element-menu-check-element2'
                      }
                      onClick={() => onCheckList(key)}>
                      <div className="all-category">
                        {categoryCode[key].title}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div
          className="calculate-content-element-menu-btn mobileoff"
          onClick={() => {}}>
          <Button className="excel" onClick={() => onDownload()}>
            엑셀 다운로드 &nbsp;
            <img
              style={{ display: 'inline' }}
              src={image.DownloadIcon}
              className="download-img"
              alt=""
            />
          </Button>
        </div>
        <div className="calculate-content-date cal-date-sub mobileoff">
          <div className="card-statics-menu-text">기간조회</div>
          <div
            className={dateType === defDateType.daily && skinType === "GOGOIT" ?
                'gogoit-alllist-list-menu-text2 active2' :
                skinType === "GOGOIT" ? 'gogoit-alllist-list-menu-text2'
                    : dateType === defDateType.daily ? 'alllist-list-menu-text2 active2' : 'alllist-list-menu-text2'
            }
            onClick={() => onChangeDateType(defDateType.daily)}>
            오늘
          </div>
          {/* <div
            className={
              "alllist-list-menu-text2" +
              (dateType === defDateType.weekly ? " active2" : "")
            }
            onClick={() => onChangeDateType(defDateType.weekly)}
          >
            일주일
          </div> */}
          <div
            className={dateType === defDateType.monthly && skinType === "GOGOIT" ?
                'gogoit-alllist-list-menu-text2 active2' :
                skinType === "GOGOIT" ? 'gogoit-alllist-list-menu-text2'
                    : dateType === defDateType.monthly ? 'alllist-list-menu-text2 active2' : 'alllist-list-menu-text2'
            }
            onClick={() => onChangeDateType(defDateType.monthly)}>
            한달
          </div>
          <div
            className={dateType === defDateType.range && skinType === "GOGOIT"
                ? 'gogoit-alllist-list-menu-text2 active2'
                : skinType === "GOGOIT"
                    ? 'gogoit-alllist-list-menu-text2'
                    : dateType === defDateType.range
                        ? 'alllist-list-menu-text2 active2'
                        : 'alllist-list-menu-text2 del-menu-text2-sub'
            }
            onClick={() => onChangeDateType(defDateType.range)}>
            날짜지정
          </div>
          <DatePicker
            className="desk"
            placeholder={'시작일'}
            locale={locale}
            style={{ height: '50px', borderRadius: '10px', marginTop: '-5px' }}
            size="large"
            format={dateFormat}
            value={moment(pagination.startDate, dateFormat)}
            onChange={onChangeDatePickerStart}
            inputReadOnly
            showToday={false}
          />
          <DatePicker
            className="desk"
            placeholder={'종료일'}
            locale={locale}
            style={{ height: '50px', borderRadius: '10px', marginTop: '-5px' }}
            size="large"
            format={dateFormat}
            value={moment(pagination.endDate, dateFormat)}
            onChange={onChangeDatePickerEnd}
            inputReadOnly
            showToday={false}
          />
          <div className="datepicker">
            <DatePicker
              className="pos"
              placeholder={'시작일'}
              locale={locale}
              style={{
                height: '40px',
                borderRadius: '10px',
                marginTop: '-5px',
              }}
              size="middle"
              format={dateFormat}
              value={moment(pagination.startDate, dateFormat)}
              onChange={onChangeDatePickerStart}
              inputReadOnly
              showToday={false}
            />
            <DatePicker
              className="pos"
              placeholder={'종료일'}
              locale={locale}
              style={{
                height: '40px',
                borderRadius: '10px',
                marginTop: '-5px',
              }}
              size="middle"
              format={dateFormat}
              value={moment(pagination.endDate, dateFormat)}
              onChange={onChangeDatePickerEnd}
              inputReadOnly
              showToday={false}
            />
          </div>
          {/* <RangePicker
            className="desk"
            placeholder={["시작일", "종료일"]}
            locale={locale}
            style={{ height: "50px", borderRadius: "10px", marginTop: "-5px" }}
            size="large"
            format={dateFormat}
            value={[
              moment(pagination.startDate, dateFormat),
              moment(pagination.endDate, dateFormat),
            ]}
            onChange={onChangeRangePicker}
          /> */}
          {/* <RangePicker
            className="pos"
            placeholder={["시작일", "종료일"]}
            locale={locale}
            style={{ height: "40px", borderRadius: "10px", marginTop: "-5px" }}
            size="middle"
            format={dateFormat}
            value={[
              moment(pagination.startDate, dateFormat),
              moment(pagination.endDate, dateFormat),
            ]}
            onChange={onChangeRangePicker}
          /> */}
        </div>
      </div>
      <div className="allList-element-all">
        <div className="allList-element-block">
          <div className="allList-element-block-menu">
            <div className="allList-element-block-menu-text mobileoff">
              주문번호
            </div>
            <div className="allList-element-block-menu-text all-sub1">일시</div>
            <div className="allList-element-block-menu-text all-sub2">분류</div>
            <div className="allList-element-block-menu-text all-sub4">대상</div>
            <div className="allList-element-block-menu-text">금액</div>
            <div className="allList-element-block-menu-text">거래 후 잔액</div>
            <div className="allList-element-block-menu-text">미수금</div>
            <div className="allList-element-block-menu-text">미수금증감분</div>
            <div className="allList-element-block-menu-text all-sub7 mobileoff" style={{width: '8%'}}>
              메모
            </div>
          </div>
        </div>

        {(!list || list.length) === 0 && (
          <div style={{ textAlign: 'center', padding: '50px' }}>
            내역이 없습니다.
          </div>
        )}
        {list &&
          list.map((row, index) => (
            <div
              key={index}
              className={
                'allList-element-block-field' + (index % 2 === 0 ? '' : ' odd')
              }>
              <div className="allList-element-block-field-text all-sub3 mobileoff">
                {row.orderIdx}
              </div>
              <div className="allList-element-block-field-text all-sub1">
                {moment(row.createDate).format('MM-DD HH:mm')}
              </div>
              <div className="allList-element-block-field-text all-sub2">
                {allCategoryCode[row.category]}
              </div>
              <div className="allList-element-block-field-text all-sub4">
                {row.riderName ? row.riderName : '-'}
              </div>
              <div
                //className="allList-element-block-field-text all-sub5"
                className={
                  'allList-element-block-field-text all-sub' +
                  (row.ncashDelta > 0 ? '5' : '8')
                }>
                {comma(row.ncashDelta)}
              </div>
              <div className="allList-element-block-field-text all-sub6">
                {comma(row.afterNcash)}
              </div>
              <div className="allList-element-block-field-text all-sub6">
                {comma((row.misu1 ?? 0) + (row.misu2 ?? 0) + (row.misu3 ?? 0))}
              </div>
              <div className="allList-element-block-field-text all-sub6">
                {comma(row.ncashDeltaMisu ?? 0)}
              </div>
              {row.memo.length > 27 ? (
                <div className="allList-element-block-field-text all-sub7 field-memo mobileoff">
                  <div className="allList-element-block-field-text memo-txt">
                    {row.memo}
                  </div>
                  <div
                    className="allList-element-block-field-moreBtn"
                    onClick={() => openDetailModal(row)}>
                    더보기
                  </div>
                </div>
              ) : (
                <div className="allList-element-block-field-text all-sub7">
                  {row.memo.replace("(지)","")}
                  {row.memo.indexOf("(지)") >= 0 && (
                    <div className="allList-element-block-field-text support-icon">지</div>
                  )}
                </div>
              )}
            </div>
          ))}
      </div>

      <div className="allList-element-btn mobileoff">
        <Pagination
          current={pagination.current}
          total={total}
          pageSize={pagination.pageSize}
          pagedListSize={PagedListSize}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default AllList;
